var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicsvgDownload17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "306.000000pt",
    viewBox: "0 0 300.000000 306.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,306.000000) scale(0.050000,-0.050000)",
    fill: "#59c030",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5897 5667 c-11 -37 -5 -42 37 -35 36 7 45 2 34 -16 -8 -14 -7 -19 3 -11 28 26 24 95 -6 95 -15 0 -22 -8 -16 -19 6 -10 3 -23 -7 -30 -11 -6 -22 4 -26 24 -6 29 -10 28 -19 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5967 5164 c12 -19 -48 -70 -70 -58 -4 2 5 -7 20 -20 15 -13 20 -34 12 -48 -10 -16 -7 -19 9 -9 13 8 20 25 16 38 -5 13 4 38 20 56 22 25 23 37 4 48 -15 9 -19 7 -11 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 4746 c-796 -178 -1176 -634 -1119 -1342 20 -260 230 -612 452 -760 28 -19 91 -60 139 -93 792 -528 2019 75 2018 992 -1 710 -803 1358 -1490 1203z m500 -163 c210 -55 452 -191 557 -314 411 -480 387 -1051 -61 -1470 -572 -535 -1538 -364 -1888 334 l-88 177 0 240 c0 722 727 1229 1480 1033z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965 3887 c-36 -15 -85 -115 -85 -173 0 -139 231 -221 309 -110 108 155 -50 353 -224 283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2900 3885 c-75 -29 -115 -242 -56 -301 34 -34 169 -30 227 8 151 99 -1 359 -171 293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880 3239 c0 -212 410 -464 699 -430 262 30 572 264 557 420 l-6 61 -625 5 -625 6 0 -62z m1069 -78 c36 -58 -196 -195 -393 -232 -156 -28 -535 152 -486 231 16 26 863 27 879 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5924 3690 c3 -22 -2 -51 -10 -64 -8 -13 -6 -29 5 -35 10 -7 14 -25 8 -42 -6 -16 -19 -24 -29 -18 -10 7 -13 22 -5 33 8 14 4 16 -11 7 -19 -11 -19 -21 0 -44 48 -57 100 109 55 175 -14 21 -17 18 -13 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4180 3325 c-175 -88 -241 -337 -148 -562 59 -142 58 -143 -227 -144 -328 -2 -382 -19 -433 -144 -38 -91 -38 -98 -5 -167 27 -58 32 -101 21 -218 -13 -141 -11 -149 42 -201 46 -47 55 -74 58 -180 7 -220 91 -275 452 -297 746 -47 990 108 990 628 0 266 -22 337 -164 536 -95 134 -246 437 -246 494 0 235 -152 349 -340 255z m185 -165 c53 -222 143 -469 192 -526 195 -230 231 -332 219 -619 -16 -402 -69 -440 -636 -456 -444 -13 -520 4 -520 120 0 73 32 97 140 105 184 13 122 136 -68 136 -137 0 -172 21 -172 103 0 89 50 122 161 107 107 -15 169 8 185 69 15 59 -17 71 -192 71 -169 0 -193 14 -194 114 0 94 75 116 405 116 368 0 380 12 295 283 -50 161 -50 258 -1 356 65 126 158 136 186 21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsvgDownload17);
export default __webpack_public_path__ + "static/media/picsvg_download (17).47b22951b32f6cf4441beaebe33f6786.svg";
export { ForwardRef as ReactComponent };